import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { PAGE_TITLE } from '../../Configuration'
import usePageTitle from '../../hooks/use-page-title'
import { RoleContext } from '../../store/role-context-provider'
import { SelectionContextProvider } from '../../store/selection-context-provider'
import DueOutsList from './dueout-list-table'

const DueOuts = () => {
  usePageTitle(PAGE_TITLE.DUEOUTS)
  const { allMPF, isLoading } = useContext(RoleContext)

  const navigate = useNavigate()
  if (!isLoading) {
    if (!allMPF) {
      navigate('/accessdenied')
    }
  }
  return (
    <SelectionContextProvider>
      <DueOutsList />
    </SelectionContextProvider>
  )
}
export default DueOuts
